import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'filter',
})
@Injectable()
export class FilterPipe implements PipeTransform {
  transform(items: any[], field: string | Function, value: string): any[] {
    if (!items) {
      return [];
    }
    if (!field || !value) {
      return items;
    }

    return items.filter((singleItem) =>
      (typeof field === 'function' ? field(singleItem) : singleItem[field])
        .toLowerCase()
        .includes(value.toLowerCase()),
    );
  }
}
